<template>
  <div class="c-user-info">
    <a v-if="userinfo == null" href="/login">
      <a-avatar icon="user"/> <span class="nikename">请登录</span>
    </a>
    <template v-if="userinfo != null">
      <a v-if="userinfo != null" @mouseover="triggerUserInfo(true)" @mouseleave="triggerUserInfo(false)">
        <a-avatar :src="avatars[myAvatar]" class="avatar"/>
        <span class="nikename">{{userinfo.username}}</span>
        <!-- <transition name="fade">
          <div v-if="showUserInfo && userinfo != null" class="userinfo-dropdown" @mouseover="triggerUserInfo(true)" @mouseleave="triggerUserInfo(false)">
            <a-icon type="caret-up" class="dropdown-icon"/>
            <div v-if="false">
              <a-avatar icon="user"/>
              <span class="nikename">{{userinfo.nikename}} ({{userinfo.username}})</span>
            </div>
            <div v-if="false">上次登录时间：{{userinfo.lastlogin}}</div>
            <div class="userinfo-href"  v-if="false">
              <div>
                <a href="#">用户资料</a> 
              </div>
              <div>
                <a href="#">修改密码</a> 
              </div>
              <div>
                <a href="#">登录历史</a> 
              </div>
            </div>
            <a-divider :style="{margin: '8px 0'}" v-if="false"/>
            <div class="userinfo-logout">
              <a :href="baseUrl + 'logout'">注销登录</a>
            </div>
          </div>
        </transition> -->
      </a>
      <div class="logout">
        <a :href="baseUrl + 'logout'">
          <a-icon type="logout" />
        </a>
      </div>
    </template>
  </div>
</template>
<script>
import avatars from '@/utils/avatars'
import { getUserInfo } from '@/api/v1'

const baseUrl = process.env.BASE_URL

export default {
  name: 'UserInfo',
  mounted () {
    getUserInfo().then(response => {
      if (response && response.data) {
        this.userinfo = response.data
      }
    }).catch(err => {
      // this.$message.info("您未登录或会话已过期，请重新登录！(" + err + ")")
    });
  },
  methods: {
    triggerUserInfo(flag) {
      window.clearTimeout(this.showOrHideUserInfoTimeOutIndex);
      if (flag) {
        this.showUserInfo = true;
      } else {
        this.showOrHideUserInfoTimeOutIndex = setTimeout(() => this.showUserInfo = false, 100);
      }
    },
  },
  data() {
    return {
      baseUrl,
      avatars,
      showOrHideUserInfoTimeOutIndex: null,
      showUserInfo: false,
      userinfo: null,
    }
  },
  computed: {
    myAvatar() {
      let avatarAttr = this.$_.find(this.userinfo.attributes, ['attrname', 'avatar']);
      if (avatarAttr != null && avatars[avatarAttr.attrvalue] != null) {
        return avatarAttr.attrvalue;
      } else {
        return 'avatar';
      }
    }
  }
}
</script>
<style lang="scss">
@import './index.scss';
</style>
